import { render, staticRenderFns } from "./StoreLocatorSmall.vue?vue&type=template&id=4aec705c&"
import script from "./StoreLocatorSmall.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../i18n/store-locator.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fbonnet-thirode%2Fsites-bonnet-thirode%2Fstatic-integration%2Fsrc%2Fjs%2Fcomponents%2FStoreLocatorSmall.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports